import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import AuditsQuestions from "./AuditsQuestions";
import AuditFormAnswerField from "../../Components/AuditFormAnswerField/AuditFormAnswerField";
import CustomToast from "../../Components/CustomToast/CustomToast";

function AuditsQuestionsUi({
  columns,
  data,
  onUpdate,
  loading,
  deleteAdminFn,
  onPageChange,
  tableQaury,
  totalRecords,
  setTableQaury,
  selectData,
  setFiltersId,
  setSelectData,
  filtersId,
  removeFilter,
  decodedToken,
  handleDrag,
  handleDrop,
  containerRef,
  handleDragOver,
  setDeleteId,
  toast
}) {
  
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <ContentHeader
              title={"Audit Questions"}
              buttonName={"Add Audit Question"}
              buttonBoolean={true}
              pageName={""}
              linkPath={"/create-audit-question"}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body"   ref={containerRef}>
                      {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        <div className="mb-3">
                        <Search
                          setTableQaury={setTableQaury}
                          tableQaury={tableQaury}
                          placeHolder={"Search By Question"}
                        />
                        </div>
                        {/* <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        /> */}
                        <>
                        {data?.length > 0 ?
                          data
                          .sort((a, b) => a.sequence - b.sequence) 
                            .map((box, index) => (
                              <div
                                draggable={box?.default_question_type !== "audit_date"}
                                id={box?.id}
                                // onDragOver={(ev) => ev.preventDefault()}
                                onDragStart={box?.default_question_type !== "audit_date" ? handleDrag : (ev) => ev.preventDefault()}
                                onDragOver={box?.default_question_type !== "audit_date" ? handleDragOver : (ev) => ev.preventDefault()}
                                onDrop={box?.default_question_type !== "audit_date" ? handleDrop : (ev) => ev.preventDefault()}
                                className=" border border-gray rounded w-100 h-100 p-2 mt-2 cursor-pointer"
                              >
                                <div className="d-flex justify-content-between ">
                                  <div className="d-flex">
                                  <i class="fas fa-grip-vertical"></i>
                                    <h6 className="ml-2">Q. {index + 1}  {box?.question}{" "}
                                      {box?.mandatory ? (
                                        <span className="text-red">*</span>
                                      ) : null}
                                      {box?.reference_para ? (
                                        <span className="ml-2">({box?.reference_para})</span>
                                      ) : null}
                                      </h6>
                                  </div>
                                  {
                                  box?.default_question_type !== "audit_date" ?
                                  
                                  <div className="d-flex justify-content-end">
                                    <button
                                      className="border-0 bg-transparent"
                                      type="button"
                                        onClick={() => onUpdate(box)}
                                    >
                                      <i className="fas fa-edit text-success">
                                        {" "}
                                      </i>
                                    </button>
                                    <button
                                      className="border-0 bg-transparent"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#modal-danger"
                                        onClick={() => setDeleteId(box?.id)}
                                    >
                                      <i className="fas fa-trash text-danger">
                                        {" "}
                                      </i>
                                    </button>
                                  </div>
:null}
                                </div>
                                {/* <hr className="my-1"></hr> */}
                                <div className="px-2">
                                  <div>
                                   
                                  </div>
                                  {box?.checkbox_type ==
                                  "multiple" ? (
                                    box?.sub_question?.map((val,ind) => {
                                      return (
                                        <div className="p-2">
                                          <div>
                                            <h6>
                                            Q.{index + 1}.{ind + 1}  {val.question}{" "}
                                              {val.mandatory ? (
                                                <span className="text-red">
                                                  *
                                                </span>
                                              ) : null}
                                            </h6>
                                          </div>
                                          <AuditFormAnswerField values={val}/>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <AuditFormAnswerField
                                      values={box}
                                      index={index}
                                    />
                                  )}
                                </div>
                              </div>
                              
                            ))
                            :
                            "No Data Available"}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAdminFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default AuditsQuestionsUi;
